import { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import LoadingSpinner from '@/components/ui/LoadingSpinner';
import { Router as AppRouter } from './Router';

function ReactRouterProvider() {
    return (
        <Router>
            <Suspense fallback={<LoadingSpinner />}>
                <AppRouter />
            </Suspense>
        </Router>
    );
}

export default ReactRouterProvider;
